import React, { useState } from 'react';
// import { Row, Col, Table, Card, Form, Input, DatePicker, Select, Button } from 'antd';
import DataEntry from '../data_entry';

const isEditting = true;

export default function DetailsPage(props){
    const [invoiceDetails] = useState(props);
    // console.log('details and update', props);

    return(
        <div>
            <DataEntry 
                invoiceDetails={invoiceDetails.location.state.record} 
                isEditting={isEditting}
            />
        </div>
    );
}